const round2 = (n) => Math.round(n * 100) / 100;

const toBool = (v) => v === true || v === 1 || v === '1';

export function calculateOrderTotals(items, taxConfig) {
  const gross = (items || []).reduce((sum, item) => {
    const price = parseFloat(item?.price) || 0;
    const qty = parseInt(item?.quantity, 10) || 0;
    return sum + price * qty;
  }, 0);

  const enabled = toBool(taxConfig?.tax_enabled);
  const rate = parseFloat(taxConfig?.tax_rate) || 0;
  const inclusive = toBool(taxConfig?.tax_inclusive);

  if (!enabled || rate <= 0) {
    return {
      subtotal: round2(gross),
      tax_amount: 0,
      total: round2(gross),
      tax_rate: rate,
      tax_inclusive: inclusive,
      tax_active: false,
    };
  }

  if (inclusive) {
    const subtotal = gross / (1 + rate / 100);
    const tax_amount = gross - subtotal;
    return {
      subtotal: round2(subtotal),
      tax_amount: round2(tax_amount),
      total: round2(gross),
      tax_rate: rate,
      tax_inclusive: true,
      tax_active: true,
    };
  }

  const tax_amount = gross * (rate / 100);
  return {
    subtotal: round2(gross),
    tax_amount: round2(tax_amount),
    total: round2(gross + tax_amount),
    tax_rate: rate,
    tax_inclusive: false,
    tax_active: true,
  };
}
